import { Subject } from "rxjs";
import { apiUrls } from "../Common";
import API from "../Common/AxiosConfiguration";
import APINode from "../Common/AxiosNodeConfiguration";
import APINodeSuperBaby from "../Common/AxiosSuperBabyNodeConfiguration";

const subject = new Subject();

export const BabyMintingService = {
  getObserved: () => subject.asObservable(),
  getServerLogin: async (form) => {
    const response = await API.post(`${apiUrls.login}`, form);
    return response;
  },
  getGenesisToken: async (form) => {
    const response = await API.post(`${apiUrls.getGenesisToken}`, form);
    return response;
  },
  getSuperBabyToken: async (form) => {
    const response = await API.post(`${apiUrls.getSuperBabyToken}`, form);
    return response;
  },
  checkSuperBabyTokensAvailable: async (form) => {
    const response = await API.post(
      `${apiUrls.checkSuperBabyTokensAvailable}`,
      form
    );
    return response;
  },
  addMint: async (form) => {
    const response = await API.post(`${apiUrls.addMint}`, form);
    return response;
  },
  addSuperBabyMint: async (form) => {
    const response = await API.post(`${apiUrls.addSuperBabyMint}`, form);
    return response;
  },
  getNodeLogin: async (form) => {
    const response = await APINode.post(`${apiUrls.login}`, form);
    return response;
  },
  generateAddressHash: async (form) => {
    const response = await APINode.post(`${apiUrls.addressHash}`, form);
    return response;
  },
  getSuperBabyNodeLogin: async (form) => {
    const response = await APINodeSuperBaby.post(`${apiUrls.login}`, form);
    return response;
  },
  generateSuperBabyAddressHash: async (form) => {
    const response = await APINodeSuperBaby.post(
      `${apiUrls.addressHash}`,
      form
    );
    return response;
  },
  getSuperBabyMintedList: async (form) => {
    const response = await API.post(`${apiUrls.getSuperBabyMintedList}`, form);
    return response;
  },
  getWalletOfOwnerFromServer: async (form) => {
    const response = await API.post(`${apiUrls.getWalletScTokens}`, form);
    return response;
  },
  walletAddressTransfer: async (form) => {
    const response = await API.post(`${apiUrls.walletAddressTransfer}`, form);
    return response;
  },
  getSeperateGenesis: async (form) => {
    const response = await API.post(`${apiUrls.getTokensByGender}`, form);
    return response;
  },
  updateGenesisPair: async (form) => {
    const response = await API.post(`${apiUrls.updateGenesisPair}`, form);
    return response;
  },
  manageErrorLog: async (form) => {
    const response = await API.post(`${apiUrls.addMetamaskErrorLog}`, form);
    return response;
  },
};
